import * as types from "../actions/types";



const initialState = {

};


export default function method_assoc_levels(state = initialState, action) {
  switch (action.type) {
    case types.GET_METHOD_ASSOC_LEVELS:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_EDU_DIRECTIONS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}